import React, { useMemo } from 'react';

import { buildSafeRichHtml } from './SafeRichContent';
import { sanitizeTableCellHtml } from './tableCellContent';


const TableCellRichContent = ({
  html,
  fallbackText = '',
  className = '',
}) => {
  const safeHtml = useMemo(() => sanitizeTableCellHtml(html), [html]);
  const renderedHtml = useMemo(
    () => (safeHtml ? buildSafeRichHtml(safeHtml, [], []) : ''),
    [safeHtml]
  );
  const classes = `book-table-cell-text ${className}`.trim();

  if (!renderedHtml) {
    return <span className={classes}>{String(fallbackText ?? '')}</span>;
  }

  return (
    <div
      className={`${classes} book-table-cell-rich-content`.trim()}
      dangerouslySetInnerHTML={{ __html: renderedHtml }}
    />
  );
};

export default TableCellRichContent;
